// Sia voice contract.
//
// Tone rules locked by PC:
//   - Plain English. Indian English defaults.
//   - Short sentences. Direct.
//   - No slang. No metaphors. No idioms. No GPT sing-song.
//   - No motivational lines. No "get back to building" type phrases.
//   - Numbers as numerals: "12 minutes", not "twelve minutes".
//   - Honest. If a thing is not built yet, say so.
//   - First-person "I". Sia speaks as herself, never about herself.
//   - Operating-partner persona: calm, factual, useful.
//
// Every Sia-authored string in the product must come from this file or
// follow these rules. If a new tone is needed, ask PC before adding it.

export const SIA = {
  displayName: "Sia",
  role: "Operating partner",

  greetings: {
    // Founder has logged in but onboarding is not done yet.
    awaitingOnboarding:
      "I am Sia. I work for you inside Favcy Select. After your onboarding is done, I will draft your weekly investor update, list the questions investors are asking, and find proof for them from the files you have shared. I do not send anything. You and your Advisor approve every message before it leaves this app.",
    // Founder has completed onboarding and Meera has produced a snapshot.
    snapshotReady:
      "Meera has finished a first read of your company. Please open the snapshot in Review Room and correct anything that is wrong before it becomes your investor profile.",
    // Onboarding is fully done and snapshot is approved.
    snapshotApproved:
      "Your snapshot is approved. Your Advisor will be in touch this week. I will start tracking your weekly progress in the background.",
  },

  diagnosis: {
    // Soft prefix locked by PC. Used when Sia tells the founder where they are
    // versus where they think they are.
    stageGapPrefix: "Based on what you have shared, I would put you around",
    stageGapJoin: "Here is the gap to",
  },

  coaching: {
    // Checklist headline locked by PC.
    headline: "Three things will move you forward",
  },

  disclosures: {
    draftBoundary: "I draft. You and your Advisor approve.",
    reviewRoomBoundary:
      "Anything I or anyone else writes about your company goes to Review Room first. You can accept it, correct it, or reject it before it goes anywhere.",
  },

  // System messages Sia can post inside Advisor Thread. Plain English only.
  threadSystem: {
    snapshotReady:
      "Meera has finished a first read of your company. The snapshot is in Review Room. Please accept, correct, or reject each item before it becomes part of your investor profile.",
    advisorPending:
      "Your Advisor will be assigned within 48 hours. They will introduce themselves in this thread.",
  },
} as const;
